import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'services/auth.service';
import { GlobalService } from 'services/global.service';

@Component({
  selector: 'app-page-nav-bar-header',
  templateUrl: './pageNavBarHeader.component.html',
  styleUrls: ['./pageNavBarHeader.component.css']
})
export class PageNavBarHeaderComponent implements OnInit {
  cssClass = "";
  timeout;
  username;

  constructor(
    private globalService : GlobalService,
    private router: Router,
    private authService: AuthService,
  ) { 

  }

  ngOnInit() {
    if (this.authService.user.username) {
      this.username = this.authService.user.username;
    } else {
      this.username = this.authService.user.last_name + " " + this.authService.user.first_name;
    }
  }

  clickDropDown() {
    if (this.cssClass == "") {
      this.cssClass = "show"
      this.timeout = setTimeout(() => {
        this.cssClass = "";
      },3000);
    } else {
      this.cssClass = "";
      clearTimeout(this.timeout);
    }
  }

  logOut() {
    var role = this.authService.role;
    if(confirm("ログアウトしますか？")) {
      const auth = this.authService.deleteAuth();
      
      if(!auth){
        if(role == 'student'){
          this.router.navigate(['/student/login']); // Navigate to dashboard view
        }else{
          this.router.navigate(['/login']); // Navigate to dashboard view
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/component/elements/pageNavBarHeader/pageNavBarHeader.component.ts